export default __webpack_public_path__ + "static/media/avatar_10.daed0e56.svg";